// @file EraserTool for tldraw -- Replacement for the built-in eraser tool
// Original file: https://github.com/tldraw/tldraw/blob/main/packages/tldraw/src/lib/tools/EraserTool/EraserTool.ts
// Extra features:
// - Mark as erasing only shapes created by the user when the user can't edit.
// - Erase only `draw` and `highlight` shapes
/* eslint-disable no-restricted-imports */

import { StateNode } from '@tldraw/editor'
import type { TLStateNodeConstructor } from 'tldraw'
import { Erasing } from './childStates/Erasing'
import { Idle } from './childStates/Idle'
import { Pointing } from './childStates/Pointing'

export default class EraserTool extends StateNode {
  static override id = 'padlet-draw-eraser' // Original id was 'eraser', but we need to change it to avoid conflicts with the built-in eraser tool
  static override initial = 'idle'
  static override isLockable = false
  static override children = (): TLStateNodeConstructor[] => [Idle, Pointing, Erasing]

  override onEnter = (): void => {
    this.editor.setCursor({ type: 'cross', rotation: 0 })
  }
}
